import React from "react";
import * as Yup from "yup";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useFormik } from "formik";
import { Auth } from "@aws-amplify/auth";
import { Button, BUTTON_SIZES } from "../components/Button";
import AuthInput from "components/AuthInput";
import AuthLayout from "components/AuthLayout";
import { authSubmitButtonStyles, authLinkButtonStyles } from "utils/constants";

/* eslint-disable no-console */

export default function ResetPassword() {
  const [submitting, setSubmitting] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string>("");
  const navigate = useNavigate();

  const { handleSubmit, handleChange, touched, errors, values } = useFormik({
    initialValues: {
      email: ""
    },
    validationSchema: ResetPasswordSchema,
    validateOnChange: true,
    validateOnMount: false,
    validateOnBlur: false,
    onSubmit: async ({ email }: { email: string }) => {
      try {
        setSubmitting(true);
        await Auth.forgotPassword(email.toLowerCase());
        return navigate(`/verify-reset?email=${email.toLowerCase()}`);
      } catch (error: any) {
        setError(error.message);
      } finally {
        setSubmitting(false);
      }
    }
  });

  return (
    <>
      <Helmet>
        <title>Pointment | Reset Password</title>
        <meta property="og:title" content="Pointment | Reset Password" />
      </Helmet>
      <AuthLayout title="Reset your password" error={error} setError={setError}>
        <form onSubmit={handleSubmit}>
          <AuthInput
            type="email"
            name="email"
            label="Email"
            placeholder="hello@pointmentapp.com"
            value={values.email}
            onChange={handleChange}
            touched={touched}
            errors={errors}
            autocapitalize="none"
          />
          <div className="flex gap-[16px]">
            <Link className="cursor-pointer w-full" to={"/login"} tabIndex={-1}>
              <Button
                className={authLinkButtonStyles}
                text={"Return to sign in"}
                size={BUTTON_SIZES.MEDIUM}
                type="button"
                backIcon
              />
            </Link>
            <Button
              className={authSubmitButtonStyles}
              text={"Continue"}
              type="submit"
              size={BUTTON_SIZES.MEDIUM}
              submitting={submitting}
              disabledOnSubmit
            />
          </div>
        </form>
      </AuthLayout>
    </>
  );
}

const ResetPasswordSchema = Yup.object().shape({
  email: Yup.string().email().required("This field is required")
});
